import React, { useState } from "react";
import { CLICK, INPUT, POPUP, component, demoFile, feature, story } from "system/demo";
import {
    CommentEditBottomWidget,
    CommentEditTopWidget,
    ComposerTopWidget,
    CommentAction,
    CommentRightAction,
    CommentPostModal,
    ComposerTopBanner,
    TopBanner,
    PageTopWidget,
    PageTopRightWidget,
    PageTopLeftWidget,
    PageBottomWidget,
} from "../comment-config";
import { CTAButton } from 'component/button';
import { t } from "util/stdtypes";

demoFile('feature/comments/comment-config');

const comment = [
    {key: 1, from: 'a', text: 'I love this movie!'},
    {key: 2, from: 'b', text: 'I hate it'},
    {key: 3, from: 'c', replyTo: 1, text: 'I can reply'},
    {key: 4, from: 'd', replyTo: 3, text: 'I can reply to the reply'},
    {key: 5, from: 'e', text: 'godzilla rules'},
    {key: 6, from: 'f', text: 'cat comment'},
]

feature('Comment Config', {
    structureKey: 'question',
    features: {config_comment: true},
    state: {collections: {comment}}
});


const CommentEditTopWidgetDemo = () => {
    const [commentState, setCommentState] = useState({text: 'hi'});
    return <CommentEditTopWidget comment={commentState} setComment={setCommentState} />;
};
component('CommentEditTopWidget', CommentEditTopWidgetDemo, {}, [
    story('Click', [CLICK('Comment Edit Top Widget')])
]);
const CommentEditBottomWidgetDemo = () => {
    const [commentState, setCommentState] = useState({text: 'hi'});
    return <CommentEditBottomWidget comment={commentState} setComment={setCommentState} />;
};
component('CommentEditBottomWidget', CommentEditBottomWidgetDemo, {}, [
    story('Click', [CLICK('Comment Edit Bottom Widget')])
]);
const ComposerTopWidgetDemo = () => {
    const [commentState, setCommentState] = useState({text: 'hi'});
    return <ComposerTopWidget comment={commentState} setComment={setCommentState} />;
};
component('ComposerTopWidget', ComposerTopWidgetDemo, {}, [
    story('Add dragon', [CLICK('Add Komodo Dragon')])
]);
component('CommentAction', CommentAction, {}, [
    story('Click', [CLICK('Comment Action')])
]);
component('CommentRightAction', CommentRightAction, {}, [
    story('Click', [CLICK('Comment Right Action')])
]);
function CommentPostModalDemo() {
    const [open, setOpen] = useState(false);
    return <>
        <CTAButton text='Open Modal' onPress={() => setOpen(true)} />
        {open && <CommentPostModal onClose={() => setOpen(false)} text='Hello' />}
    </>;
}
component('CommentPostModal', CommentPostModalDemo, {}, [
    story('Close', [CLICK('Open Modal'), POPUP(CLICK('I understand'))])
]);
component('ComposerTopBanner', ComposerTopBanner);
component('TopBanner', TopBanner);
component('PageTopWidget', PageTopWidget);
component('PageTopRightWidget', PageTopRightWidget);
component('PageTopLeftWidget', PageTopLeftWidget);
component('PageBottomWidget', PageBottomWidget);






